export default __webpack_public_path__ + "static/media/date-end.eb0c7b32.svg";